import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_sftp.info.data = { ...data };
  });
};

const get = async (store, id, params = {}) => {
  store.setState((state) => {
    state.modulo.timbrado_sftp.info.busy = true;
  });

  try {
    const response = await Http.get(`api/timbrado-tickets/${id}`, { params });

    store.setState((state) => {
      state.modulo.timbrado_sftp.info.busy = false;
      state.modulo.timbrado_sftp.info.data = response.data;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_sftp.info.busy = false;
      state.modulo.timbrado_sftp.info.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.timbrado_sftp.info.error = undefined;
};

const reset = (store) => (state) => {
  state.modulo.timbrado_sftp.info = { ...initialState };
};

const actions = {
  setData,
  get,
  reset,
  resetError,
};

const TimbradoSftpInfoStore = {
  state: () => initialState,
  actions,
};

export default TimbradoSftpInfoStore;
